import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Role } from '../../components/auth-context/role';
import { AdminDashboard } from './admin-dashboard';
import {NotamsManager} from "./notams-manager";
import {RulesManager} from "./rules-manager";
import {EventManager} from "./event-manager";
import {SocialManager} from "./social-manager";
import {PermissionManager} from "./permission-manager";
import {ConfigWebsite} from "./config-website";
import {Request, RequestJoinManager} from "./request";
import {StaffListManager} from "./staff-list-manager";
import {DocumentationManager} from "./documentation-manager";
import {SimulatorManager} from "./simulator-manager";
import {AircraftManager} from "./aircraft-manager";
import {RankManager} from "./rank-manager";
import {FleetManager} from "./fleet-manager";
import {PaintkitManager} from "./paintkit-manager";
import {AirportManager} from "./airport-manager";
import {AirlineManager} from "./airline-manager";
import {HubManager} from "./hub-manager";
import {MedalManager} from "./medal-manager";
import {MedalUserManager} from "./medal-user-manager";
import {UserManager} from "./user-manager";
import {FlightManager} from "./flight-manager";
import {RouteManager} from "./route-manager";
import CareerManager from "./career-manager";
import { TourManager } from "./tour-manager";
import './admin-zone.scss'
import {
    faAddressCard,
    faAward,
    faBook,
    faBrush, faBuilding, faBuildingColumns, faCalendarDays,
    faDatabase, faDiagramProject,
    faFile,
    faGears,
    faList, faMedal, faMessage, faPaperPlane, faPlaneCircleCheck, faPlaneUp, faRankingStar, faRoute, faSchool,
    faSignsPost, faSquareShareNodes,
    faUsersGear, faUsersSlash
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export function AdminZone() {
    const { t } = useTranslation();
    const [activeSection, setActiveSection] = useState(null);

    const toggleSection = (section) => {
        setActiveSection(activeSection === section ? null : section);
    };

    const renderSectionContent = () => {
        switch (activeSection) {
            case 'permissions':
                return (
                    <PermissionManager />
                );
            case 'rules':
                return (
                    <RulesManager />
                );
            case 'documents':
                return (
                    <DocumentationManager />
                );
            case 'paints':
                return (
                    <PaintkitManager />
                );
            case 'tours':
                return (
                    <TourManager />
                );
            case 'users':
                return (
                    <UserManager />
                );
            case 'notams':
                return (
                    <NotamsManager />
                );
            case 'events':
                return (
                    <EventManager/>
                );
            case 'social':
                return (
                    <SocialManager />
                );
            case 'fleet':
                return (
                    <FleetManager />
                );
            case 'aircraft':
                return (
                    <AircraftManager />
                );
            case 'routes':
                return (
                    <RouteManager />
                );
            case 'config':
                return (
                    <ConfigWebsite />
                );
            case 'request':
                return (
                    <RequestJoinManager />
                );
            case 'staff':
                return (
                    <StaffListManager />
                );
            case 'simulator':
                return (
                    <SimulatorManager />
                );
            case 'rank':
                return (
                    <RankManager />
                );
            case 'airport':
                return (
                    <AirportManager />
                );
            case 'airlines':
                return (
                    <AirlineManager />
                );
            case 'hub':
                return (
                    <HubManager />
                );
            case 'awards':
                return (
                    <MedalManager />
                );
            case 'awards-user':
                return (
                    <MedalUserManager />
                );
            case 'validation':
                return (
                  <FlightManager />
                );
            case 'career':
                return (
                  <CareerManager />
                );

            default:
                return <AdminDashboard />;
        }
    };

    return (
        <>
        <div className="view-model">
            <div>
                <h1>{t('admin-zone')}</h1>
                <div className="admin-buttons">
                    <Role has="ADMIN">
                    <button
                        className={`btn ${activeSection === 'permissions' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('permissions')}
                    >
                        <FontAwesomeIcon icon={faDatabase} /> {t('permission-manager')}
                    </button>
                    <button
                        className={`btn ${activeSection === 'staff' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('staff')}
                    >
                        <FontAwesomeIcon icon={faList} /> {t('staff-list-manager')}
                    </button>
                    <button
                        className={`btn ${activeSection === 'config' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('config')}
                    >
                        <FontAwesomeIcon icon={faGears} /> {t('config-website')}
                    </button>
                </Role>
                <Role has="RULE_ADMIN">
                    <button
                        className={`btn ${activeSection === 'rules' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('rules')}
                    >
                        <FontAwesomeIcon icon={faBook} /> {t('rule-manager')}
                    </button>
                </Role>
                <Role has="DOC_MANAGER">
                    <button
                        className={`btn ${activeSection === 'documents' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('documents')}
                    >
                        <FontAwesomeIcon icon={faFile} /> {t('documentation-manager')}
                    </button>
                </Role>
                <Role has="PAINT_MANAGER">
                    <button
                        className={`btn ${activeSection === 'paints' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('paints')}
                    >
                        <FontAwesomeIcon icon={faBrush} /> {t('paintkit-manager')}
                    </button>
                </Role>
                <Role has="TOUR_MANAGER">
                    <button
                        className={`btn ${activeSection === 'tours' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('tours')}
                    >
                        <FontAwesomeIcon icon={faSignsPost} /> {t('tour-manager')}
                    </button>
                </Role>
                <Role has="USER_MANAGER">
                    <button
                        className={`btn ${activeSection === 'users' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('users')}
                    >
                        <FontAwesomeIcon icon={faUsersGear} /> {t('user-manager')}
                    </button>
                    <button
                        className={`btn ${activeSection === 'request' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('request')}
                    >
                        <FontAwesomeIcon icon={faUsersSlash} /> {t('request-join-manager')}
                    </button>
                    <button
                        className={`btn ${activeSection === 'rank' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('rank')}
                    >
                        <FontAwesomeIcon icon={faRankingStar} /> {t('rank-manager')}
                    </button>
                    <button
                        className={`btn ${activeSection === 'awards' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('awards')}
                    >
                        <FontAwesomeIcon icon={faAward} /> {t('awards-manager')}
                    </button>
                    <button
                        className={`btn ${activeSection === 'awards-user' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('awards-user')}
                    >
                        <FontAwesomeIcon icon={faMedal} /> {t('awards-user-manager')}
                    </button>
                    <button
                        className={`btn ${activeSection === 'career' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('career')}
                    >
                        <FontAwesomeIcon icon={faSchool} /> {t('career-manager')}
                    </button>
                </Role>
                <Role has="NOTAMS_MANAGER">
                    <button
                        className={`btn ${activeSection === 'notams' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('notams')}
                    >
                        <FontAwesomeIcon icon={faMessage} /> {t('notams-manager')}
                    </button>
                </Role>
                <Role has="EVENT_MANAGER">
                    <button
                        className={`btn ${activeSection === 'events' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('events')}
                    >
                        <FontAwesomeIcon icon={faCalendarDays} /> {t('event-manager')}
                    </button>
                </Role>
                <Role has="SOCIAL_MANAGER">
                    <button
                        className={`btn ${activeSection === 'social' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('social')}
                    >
                        <FontAwesomeIcon icon={faSquareShareNodes} /> {t('social-networks-manager')}
                    </button>
                </Role>
                <Role has="OPERATIONS_MANAGER">
                    <button
                        className={`btn ${activeSection === 'fleet' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('fleet')}
                    >
                        <FontAwesomeIcon icon={faPaperPlane} /> {t('fleet-manager')}
                    </button>
                    <button
                        className={`btn ${activeSection === 'aircraft' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('aircraft')}
                    >
                        <FontAwesomeIcon icon={faPlaneUp} /> {t('aircraft-manager')}
                    </button>
                    <button
                        className={`btn ${activeSection === 'routes' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('routes')}
                    >
                        <FontAwesomeIcon icon={faRoute} /> {t('routes-manager')}
                    </button>
                    <button
                        className={`btn ${activeSection === 'hub' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('hub')}
                    >
                        <FontAwesomeIcon icon={faBuildingColumns} /> {t('hub-manager')}
                    </button>
                    <button
                        className={`btn ${activeSection === 'airlines' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('airlines')}
                    >
                        <FontAwesomeIcon icon={faAddressCard} /> {t('airlines-manager')}
                    </button>
                    <button
                        className={`btn ${activeSection === 'simulator' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('simulator')}
                    >
                        <FontAwesomeIcon icon={faDiagramProject} /> {t('simulators-manager')}
                    </button>
                    <button
                        className={`btn ${activeSection === 'airport' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('airport')}
                    >
                        <FontAwesomeIcon icon={faBuilding} /> {t('airports-manager')}
                    </button>
                </Role>
                <Role has={"VALIDATOR_MANAGER"}>
                    <button
                        className={`btn ${activeSection === 'validation' ? 'secondary' : ''}`}
                        onClick={() => toggleSection('validation')}
                    >
                        <FontAwesomeIcon icon={faPlaneCircleCheck} /> {t('validation-flights-manager')}
                    </button>
                    </Role>
                </div>
            </div>

        </div>
            <div className={"view-model"}>
            {renderSectionContent()}
            </div>
        </>
    );
}